import axiosInstance from '../utils/axios';

/**
 * Generate a new offer letter for a lead
 * @param {Object} offerLetterData - Offer letter request data
 * @param {string} offerLetterData.leadId - Lead ID
 * @param {string} offerLetterData.candidateName - Candidate name
 * @param {string} offerLetterData.position - Position/Role
 * @param {string} offerLetterData.salary - Salary/Compensation
 * @param {string} offerLetterData.joiningDate - Joining date
 * @param {string} offerLetterData.reportingTo - Reporting manager
 * @param {string} offerLetterData.location - Work location
 * @param {Object} offerLetterData.additionalParameters - Additional parameters
 * @returns {Promise<Object>} API response
 */
export const generateOfferLetter = async (offerLetterData) => {
    try {
        const response = await axiosInstance.post('/api/Leads/GenerateOfferLetter', offerLetterData);
        return response.data;
    } catch (error) {
        console.error('Error generating offer letter:', error);
        throw error;
    }
};
